import { SAVE_SOCIAL_MEDIA, RESET_SOCIAL_MEDIA, GET_ALL_SOCIAL_MEDIA 
} from '../actions/types';

const initialState = {
  FacebookURL: '',
  TwitterURL: '',
  InstagramURL: '',
  PinterestURL: '',
  LinkedinURL: '',
  YoutubeURL: '',
  allSocialMedia: [],

};

const socialMediaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_SOCIAL_MEDIA:
      return {
        ...state,
        ...action.payload,
      };
      case GET_ALL_SOCIAL_MEDIA:
      return {
        ...state,
        allSocialMedia: action.payload, // Store the entire array
      };
    case RESET_SOCIAL_MEDIA:
      return { ...initialState };
    default:
      return state;

      
  }
};

export default socialMediaReducer;
